import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EFXStream from 'elem/ui-assets/icons/unregular/EFXStream';
import { useEffect, useState } from 'react';

export default function TheComp() {
    const { t } = useLang('rapid.StickyA');
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            AniContainer.create({
                triggerElement: `.${css.comp}`,
                triggerHook: 1,
                offset: '150%',
                onEnter: () => setEnter(true),
                onLeave: () => setEnter(false),
            });
        }
    });

    return (
        <div className={css.comp}>
            <div className="sticky-box">
                <div className={`img-box ${enter ? 'enter' : ''}`}>
                    <EfImg
                        pc={'https://websiteoss.ecoflow.com/upload/image/1729514242004/pc_part01.jpg'}
                        h5={'https://websiteoss.ecoflow.com/upload/image/1729514241830/m_part01.jpg'}
                    />
                    <div className={`info ${enter ? 'enter' : ''}`}>
                        <div className="logo">
                            <EFXStream color="#fff" />
                        </div>
                        <p className="title">{t('title')}</p>
                        <p className="desc">{t('desc')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
